import { string, object } from "yup";

import { SIX_DIGIT_CODE_REGEX } from "utils/regex";

export const codeInitialValues = {
  code: "",
};

export const codeValidationSchema = object({
  code: string()
    .trim()
    .matches(SIX_DIGIT_CODE_REGEX, "Enter the 6-digit code")
    .required("Required"),
});
